<template>
  <div class="copyright">
    <div>
      联系我们: edianzhang@163.com | 电话：0755-82562190 |
      <span
        ><a
          target="_blank"
          href="http://amos.alicdn.com/msg.aw?v=2&amp;uid=e%E5%BA%97%E9%95%BF%E8%BD%AF%E4%BB%B6&amp;site=cntaobao&amp;s=1&amp;charset=utf-8"
          ><img
            border="0"
            src="http://amos.alicdn.com/online.aw?v=2&amp;uid=e%E5%BA%97%E9%95%BF%E8%BD%AF%E4%BB%B6&amp;site=cntaobao&amp;s=1&amp;charset=utf-8"
            alt="点击这里给我发消息"
        /></a>
      </span>
    </div>

    <div>
      Copyright©2011-2021 深圳市雨帆信息技术有限公司 e店长 All Right Reserved |
      ICP证：
      <a href="https://beian.miit.gov.cn/" target="_blank" style="">
        粤ICP备14011677号</a
      >
      |
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402005087"
        style=""
      >
        <img src="@/assets/beian.png" style="float:left;" />
        粤公网安备 44030402005087号
      </a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.copyright {
  line-height: 30px;
  color: #939393;
  a {
    display: inline-block;
    text-decoration: none;
    height: 20px;
    line-height: 20px;
  }
  a:link {
    color: #939393;
  }
  a:hover {
    color: #939393;
  }
  a:visited {
    color: #939393;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/UfFooter.vue